import { render, staticRenderFns } from "./SplashView.vue?vue&type=template&id=355bba8c&"
import script from "./SplashView.vue?vue&type=script&lang=js&"
export * from "./SplashView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports